import * as LDClient from "launchdarkly-js-client-sdk";

let ldClient: LDClient.LDClient | null = null;

export async function initializeLaunchDarkly(
  clientSideId: string,
  user: LDClient.LDSingleKindContext,
): Promise<LDClient.LDClient | null> {
  if (ldClient) {
    return ldClient;
  }

  try {
    ldClient = LDClient.initialize(clientSideId, user);
    await ldClient.waitForInitialization();
    return ldClient;
  } catch (error) {
    console.error("Failed to initialize LaunchDarkly client:", error);
    return null;
  }
}

export function trackEvent(eventKey: string, data?: any): void {
  if (!ldClient) {
    console.warn("LaunchDarkly client not initialized, event not tracked");
    return;
  }

  try {
    ldClient.track(eventKey, data);
  } catch (error) {
    console.error("Failed to track LaunchDarkly event:", error);
  }
}

export function getLaunchDarklyClient(): LDClient.LDClient | null {
  return ldClient;
}

export async function updateUser(
  user: LDClient.LDSingleKindContext,
): Promise<void> {
  if (!ldClient) {
    console.warn("LaunchDarkly client not initialized, cannot update user");
    return;
  }

  try {
    await ldClient.identify(user);
  } catch (error) {
    console.error("Failed to update LaunchDarkly user context:", error);
  }
}

export function getFeatureFlag(flagKey: string, defaultValue: any): any {
  if (!ldClient) {
    console.warn(
      "LaunchDarkly client not initialized, returning default value",
    );
    return defaultValue;
  }

  try {
    return ldClient.variation(flagKey, defaultValue);
  } catch (error) {
    console.error("Failed to get feature flag:", error);
    return defaultValue;
  }
}

export async function closeLaunchDarkly(): Promise<void> {
  try {
    if (ldClient) {
      await ldClient.close();
      ldClient = null;
    }
  } catch (error) {
    console.error("Failed to close LaunchDarkly client:", error);
  }
}
